/**
 * Pagination constants for the application
 * Centralized configuration for all pagination limits
 */

export const PAGINATION_LIMITS = {
  // Product-related pagination
  PRODUCTS: 12,           // For admin products and catalogue pages
  
  // Order-related pagination
  ORDERS: 10,            // For orders, pending orders, my orders
  
  // Workshop-related pagination
  WORKSHOP_JOBS: 10,     // For workshop jobs
  
  // Label limits (for admin labels management)
  LABELS: {
    CATEGORY: 20,
    SUBCATEGORY: 20,
    TAG: 20
  }
}

export const DEFAULT_PAGE = 1

// Helper function to get pagination object with default values
export const createPagination = (limit, page = DEFAULT_PAGE) => ({
  page,
  limit,
  total: 0,
  pages: 0
})

// Helper function to get label limit for a specific type
export const getLabelLimit = (type) => {
  return PAGINATION_LIMITS.LABELS[type.toUpperCase()] || 0
}

// Helper function to check if label limit is reached
export const isLabelLimitReached = (type, currentCount) => {
  const limit = getLabelLimit(type)
  return limit > 0 && currentCount >= limit
}
